/* eslint-disable max-len */
import { GenericBladeInitParam, GenericBladeType } from '@commblades/commblades';

const { applicationRoot } = window.NetBank;

const errorState: GenericBladeInitParam = {
    id: 'sorry',
    genericBladeType: GenericBladeType.confirm,
    urlFetchEndPoint: `${applicationRoot}sorry`,
    content: {
        heading: 'There’s a problem on our end.',
        description:
            'Something has gone wrong. You can refresh the page and try again.',
        confirmButtonText: '',
    },
};

export default errorState;
